export default "__VITE_ASSET__DfPeK2ay__"